import { isSome } from './util'

function numberWithDelimiterFilter(x: unknown): string {
  if (typeof x === 'string' || typeof x === 'number') {
    const str = x.toString()
    const [integer, decimal] = str.split('.')
    const intWithDelimiter = integer?.replace(/(\d)(?=(\d{3})+$)/g, '$1,') ?? '0'
    return isSome(decimal) ? `${intWithDelimiter}.${decimal}` : intWithDelimiter
  }
  return ''
}

export const numberUtil = {
  numberWithDelimiterFilter,
  forceNumber: (value: string | number): number => {
    if (typeof value === 'string') {
      return Number(value.replace(/,/g, '').replace(/[a-zA-Z]/g, ''))
    }
    return value
  },
}
